import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/disciplines/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listDisciplines, updateDiscipline } from "../../../redux/actions/table/superadmin/disciplines";
import EditDisciplineForm from "../../../forms/superadmin/disciplines/EditDisciplineForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateDiscipline(formData.id, _.omit(formData, ['id'])).then(() => {
                listDisciplines();

                this.props.readAction(formData.id);

                setNotification(__('superadmin.disciplines.flyout.properties.properties-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditDisciplineForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'code', 'profession']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
